webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var seasonNumber = this.episode && this.episode.airedSeason || this.seasonNumber;
  this.episode = this.$store.getters.randomEpisode(this.within, seasonNumber);
  this.$router.push({
    name: 'random-season-episode',
    params: {
      seasonNumber: this.episode.airedSeason,
      episodeNumber: this.episode.airedEpisodeNumber
    },
    query: {
      within: this.within
    }
  });
});

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(42),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8a97e5aa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(20)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(37),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2de651d9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Intro__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BrowseEpisode__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BrowseEpisode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_BrowseEpisode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_BrowseSeason__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_BrowseSeason___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_BrowseSeason__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_RandomEpisode__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_RandomEpisode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_RandomEpisode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_DrinkingRules__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_DrinkingRules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_DrinkingRules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_checkWithin__ = __webpack_require__(8);









var routes = [{
  path: '*',
  redirect: '/'
}, {
  path: '/',
  name: 'Intro',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Intro___default.a
}, {
  name: 'random-season-episode',
  path: '/Random/Season/:seasonNumber/Episode/:episodeNumber',
  component: __WEBPACK_IMPORTED_MODULE_5__components_RandomEpisode___default.a,
  props: function props(route) {
    return {
      within: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_checkWithin__["a" /* default */])(route.query.within || 'season'),
      seasonNumber: route.params.seasonNumber,
      episodeNumber: route.params.episodeNumber
    };
  }
}, {
  path: '/Browse/Season/:seasonNumber',
  component: __WEBPACK_IMPORTED_MODULE_4__components_BrowseSeason___default.a,
  props: true
}, {
  path: '/Browse/Season/:seasonNumber/Episode/:episodeNumber',
  component: __WEBPACK_IMPORTED_MODULE_3__components_BrowseEpisode___default.a,
  props: true
}, {
  path: '/DrinkingRules',
  component: __WEBPACK_IMPORTED_MODULE_6__components_DrinkingRules___default.a
}];

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: routes
}));

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_episode_data_json__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_episode_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_episode_data_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(48);




__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: {
    // skippedEpisodes: epData.map(() => {
    //   return {};
    // }),
    // viewedEpisodes: epData.map(() => {
    //   return {};
    // }),
    epData: __WEBPACK_IMPORTED_MODULE_0__assets_episode_data_json___default.a,
    allEpisodes: __WEBPACK_IMPORTED_MODULE_0__assets_episode_data_json___default.a.reduce(function (allEps, s) {
      return allEps.concat(s.episodes);
    }, [])
  },
  getters: {
    epData: function epData(state) {
      return state.epData;
    },
    episode: function episode(state) {
      return function (_seasonNumber, _episodeNumber) {
        var seasonNumber = +_seasonNumber;
        var episodeNumber = +_episodeNumber;

        return state.epData[seasonNumber - 1].episodes[episodeNumber - 1];
      };
    },
    randomEpisode: function randomEpisode(state) {
      return function (within, seasonNumber) {
        var cutoff = Date.now() - 3600 * 1000; // 60 Minutes
        var fullEpisodes = within === 'all' ? state.allEpisodes : state.epData[seasonNumber - 1].episodes;
        var episodes = fullEpisodes.filter(function (episode) {
          return !episode.viewedAt || episode.viewedAt < cutoff;
        });

        if (episodes.length === 0) {
          episodes = fullEpisodes;
        }

        var episode = episodes[Math.floor(Math.random() * episodes.length)];

        console.log(episode.episodeName, episode.viewedAt, episode.viewedAt < cutoff);

        return episode;
      };
    },
    season: function season(state) {
      return function (_seasonNumber) {
        var seasonNumber = +_seasonNumber;

        return state.epData[seasonNumber - 1];
      };
    }
  }
}));

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(38),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (within) {
  switch (within) {
    case 'season':
      return within;
    default:
      return 'all';
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(6);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a },
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */]
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Logo__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Logo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_BgVideo__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_BgVideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_BgVideo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppFooter__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AppFooter__);
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Logo: __WEBPACK_IMPORTED_MODULE_0__components_Logo___default.a, BgVideo: __WEBPACK_IMPORTED_MODULE_1__components_BgVideo___default.a, AppFooter: __WEBPACK_IMPORTED_MODULE_2__components_AppFooter___default.a },
  name: 'app'
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-footer'
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'bg-video'
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Episode__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Episode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Episode__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Episode: __WEBPACK_IMPORTED_MODULE_0__components_Episode___default.a },
  name: 'browse-episode',
  props: ['seasonNumber', 'episodeNumber'],
  data: function data() {
    return {
      episode: this.$store.getters.episode(this.seasonNumber, this.episodeNumber)
    };
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'browse-season',
  props: ['seasonNumber'],
  data: function data() {
    return {
      season: this.$store.getters.season(this.seasonNumber)
    };
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_json_loader_yaml_loader_assets_drinking_rules_yaml__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_json_loader_yaml_loader_assets_drinking_rules_yaml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_json_loader_yaml_loader_assets_drinking_rules_yaml__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'drinking-rules',
  data: function data() {
    return {
      rules: __WEBPACK_IMPORTED_MODULE_0_json_loader_yaml_loader_assets_drinking_rules_yaml___default.a
    };
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DrinkingRules__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DrinkingRules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_DrinkingRules__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { DrinkingRules: __WEBPACK_IMPORTED_MODULE_0__components_DrinkingRules___default.a },
  name: 'episode',
  props: ['episode'],
  created: function created() {
    this.setEpisodeImage();
  },
  data: function data() {
    return {
      lastSeen: Date.now()
    };
  },

  watch: {
    episode: function episode() {
      this.lastSeen = this.episode.viewedAt;
      this.episode.viewedAt = Date.now();
      this.setEpisodeImage();
    }
  },
  methods: {
    setEpisodeImage: function setEpisodeImage() {
      this.episodeImage = '/static/episode-images/tng/' + this.episode.id + '.jpg';
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_getRandomEpisode__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'intro',
  data: function data() {
    return {
      epData: this.$store.getters.epData
    };
  },

  methods: {
    getRandomEpisode: __WEBPACK_IMPORTED_MODULE_0__lib_getRandomEpisode__["a" /* default */],
    getAnyRandomEpisode: function getAnyRandomEpisode() {
      this.within = 'all';
      this.seasonNumber = 'all';
      this.getRandomEpisode();
    },
    getSeasonRandomEpisode: function getSeasonRandomEpisode(seasonNumber) {
      this.within = 'season';
      this.seasonNumber = seasonNumber;
      this.getRandomEpisode();
    }
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'logo'
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Episode__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Episode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Episode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_getRandomEpisode__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Episode: __WEBPACK_IMPORTED_MODULE_0__components_Episode___default.a },
  name: 'random-episode',
  props: ['within', 'seasonNumber', 'episodeNumber'],
  watch: {
    // Required for back/forward to work
    episodeNumber: function episodeNumber() {
      if (!this.episode || +this.episodeNumber !== this.episode.airedEpisodeNumber || +this.seasonNumber !== this.episode.airedSeason) {
        this.episode = this.$store.getters.episode(this.seasonNumber, this.episodeNumber);
      }
    }
  },
  data: function data() {
    var msg = '';
    switch (this.within) {
      case 'season':
        msg = 'Get another random episode from Season ' + this.seasonNumber + '!';
        break;
      case 'all':
        msg = 'Get another random episode from any season!';
        break;
    }

    return {
      msg: msg,
      episode: this.$store.getters.episode(this.seasonNumber, this.episodeNumber)
    };
  },

  methods: {
    getRandomEpisode: __WEBPACK_IMPORTED_MODULE_1__lib_getRandomEpisode__["a" /* default */]
  }
});

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = [
	"Anyone adjusts their uniform",
	"Anyone announces a phaser setting, 2 drinks",
	"Anyone falls down a hole, 2 drinks",
	"Anyone is thrown from their terminal in battle or otherwise",
	"Anyone plays poker",
	"Anyone says \"Containment Leak\"",
	"Anyone says \"Evasive maneuvers\"",
	"Anyone says \"Jean Luc\"",
	"Anyone says \"Level 3 Diagnostic\"",
	"Anyone says \"Maximum Warp\"",
	"Anyone says \"Red Alert\"",
	"Anyone says \"Energize\"",
	"Anyone says \"Engage\"",
	"Barclay appears in the episode, 2 drinks",
	"Data doesn't understand a colloquialism",
	"Data says \"Second Officer's Log\", 2 drinks",
	"Geordi is next to Data",
	"Guinan serves a drink and / or gives advice about some shit",
	"Neutral zone problem, 2 drinks",
	"Picard looks out the window in his Ready Room",
	"Picard runs, 2 drinks",
	"Picard says \"Captain's Log\"",
	"Picard says \"Make it so\"",
	"Picard says \"Number One\"",
	"Q appears in the episode, 2 drinks",
	"Riker does the \"Riker Lean\"",
	"Riker says \"First Officer's Log\"",
	"Saucer Section separation, 2 drinks",
	"Troi has a vision or dream",
	"Troi senses something or uses telepathy",
	"Warp Core Meltdown (or threat of a meltdown), 2 drinks",
	"Worf says \"Honor\""
];

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = [
	{
		"episodes": [
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 1,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 1.1,
				"dvdSeason": 1,
				"episodeName": "Encounter at Farpoint (1)",
				"firstAired": "1987-09-28",
				"id": 46508,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1343399184,
				"overview": "Stardate: 41153.7\r\nThe new captain of the recently built U.S.S. Enterprise-D, Captain Jean Luc Picard, takes the crew on their first mission: to discover the secret of Farpoint Station. During their journey, they encounter an omnipotent being known as Q, who accuses humanity of barbarism, and places them on trial. Jean-Luc must prove otherwise, or the human race will be annihilated.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177863"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 2,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 1.2,
				"dvdSeason": 1,
				"episodeName": "Encounter at Farpoint (2)",
				"firstAired": "1987-09-28",
				"id": 405272,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428960094,
				"overview": "Stardate: 41153.7\r\nThe new captain of the recently built U.S.S. Enterprise-D, Captain Jean Luc Picard, takes the crew on their first mission: to discover the secret of Farpoint Station. During their journey, they encounter an omnipotent being known as Q, who accuses humanity of barbarism, and places them on trial. Jean-Luc must prove otherwise, or the human race will be annihilated.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177863"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 3,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 2,
				"dvdSeason": 1,
				"episodeName": "The Naked Now",
				"firstAired": "1987-10-05",
				"id": 46510,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428960083,
				"overview": "Stardate: 41209.2\r\nThe crew of the Enterprise are infected with a virus they contracted while examining the mysterious deaths of the entire crew onboard the Starship Tsilkovsky.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177865"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 4,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 3,
				"dvdSeason": 1,
				"episodeName": "Code of Honor",
				"firstAired": "1987-10-12",
				"id": 46511,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428960076,
				"overview": "Stardate: 41235.25\r\nTasha Yar must fight for her life, and a vaccine, to save a race of people when she is kidnapped and forced to battle with her abductor's wife.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177866"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 5,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 4,
				"dvdSeason": 1,
				"episodeName": "The Last Outpost",
				"firstAired": "1987-10-19",
				"id": 46512,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428960070,
				"overview": "Stardate: 41386.4\r\nA powerful entity disables the Enterprise and a Ferengi ship. Their only means of escape is if they can correctly answer the riddles he asks.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177867"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 6,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 5,
				"dvdSeason": 1,
				"episodeName": "Where No One Has Gone Before",
				"firstAired": "1987-10-26",
				"id": 46513,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428960064,
				"overview": "Stardate: 41263.1\r\nThe Enterprise is flung across space into a distant galaxy billions of light years away when a propulsion engineer, and his mysterious companion, attempt to re-design the ship's engine systems.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177868"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 7,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 6,
				"dvdSeason": 1,
				"episodeName": "Lonely Among Us",
				"firstAired": "1987-11-02",
				"id": 46514,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428960056,
				"overview": "Stardate: 41249.3\r\nPicard's mind is taken over by an energy field that the Enterprise passes through.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177869"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 8,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 7,
				"dvdSeason": 1,
				"episodeName": "Justice",
				"firstAired": "1987-11-09",
				"id": 46515,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428960048,
				"overview": "Stardate: 41255.6\r\nPicard is forced to choose between friendship, and the Prime Directive, when Wesley Crusher accidently breaks the law and is therefore sentenced to death while on Rubicon III.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177870"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 9,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 8,
				"dvdSeason": 1,
				"episodeName": "The Battle",
				"firstAired": "1987-11-16",
				"id": 46516,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428960040,
				"overview": "Stardate: 41723.9\r\nThe Ferengi hand over an old ship which Picard once captained: the U.S.S. Stargazer. However, a mind altering device that has been planted on board alters Picard's mind to make him think that he is reliving a past battle, and the target is the Enterprise.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177871"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 10,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 9,
				"dvdSeason": 1,
				"episodeName": "Hide and Q",
				"firstAired": "1987-11-23",
				"id": 46517,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428960034,
				"overview": "Stardate: 41590.5\r\nQ places the senior crew of the Enterprise in a war game that pits them against a boar-faced, Napoleonic enemy.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177872"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 11,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 10,
				"dvdSeason": 1,
				"episodeName": "Haven",
				"firstAired": "1987-11-30",
				"id": 46518,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428960027,
				"overview": "Stardate: 41294.6\r\nLwaxana pays a surprise visit to the Enterprise and announces the pre-arranged marriage of Deanna to the son of her late husband's best friend.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177873"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 12,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 11,
				"dvdSeason": 1,
				"episodeName": "The Big Goodbye",
				"firstAired": "1988-01-11",
				"id": 46519,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428960020,
				"overview": "Stardate: 41997.7\r\nPicard, Dr. Crusher and Data are placed in great danger when the holodeck malfunctions while they are running a Dixon Hill program, which pits them against 1940's mobsters.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177874"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 13,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 12,
				"dvdSeason": 1,
				"episodeName": "Datalore",
				"firstAired": "1988-01-18",
				"id": 46520,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428960014,
				"overview": "Stardate: 41242.4\r\nThe crew of the Enterprise find android parts that are identical to Data's while they are exploring his homeworld. When assembled, an 'evil' twin of Data is created and named 'Lore'.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177875"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 14,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 13,
				"dvdSeason": 1,
				"episodeName": "Angel One",
				"firstAired": "1988-01-25",
				"id": 46521,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428960006,
				"overview": "Stardate: 41636.9\r\nThe Enterprise discovers the male crew of a crashed Federation freighter are hiding as fugitives on the planet Angel One, which is dominated and ruled by women.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177876"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 15,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 14,
				"dvdSeason": 1,
				"episodeName": "11001001",
				"firstAired": "1988-02-01",
				"id": 46522,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959998,
				"overview": "Stardate: 41365.9\r\nWhile undergoing repairs, the Bynar Engineers steal the Enterprise to save their planet from destruction.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177877"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 16,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 15,
				"dvdSeason": 1,
				"episodeName": "Too Short a Season",
				"firstAired": "1988-02-08",
				"id": 46523,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959990,
				"overview": "Stardate: 41309.5\r\nThe aging and terminally ill Starfleet Admiral Mark Jameson, who is negotiating the release of hostages, suddenly begins growing younger through an unexplained phenomenon.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177878"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 17,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 16,
				"dvdSeason": 1,
				"episodeName": "When The Bough Breaks",
				"firstAired": "1988-02-15",
				"id": 46524,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959982,
				"overview": "Stardate: 41509.1\r\nThe children of the Enterprise, including Wesley Crusher, are abducted by a race of sterile people who are unable to have children of their own.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177879"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 18,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 17,
				"dvdSeason": 1,
				"episodeName": "Home Soil",
				"firstAired": "1988-02-22",
				"id": 46525,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959974,
				"overview": "Stardate: 41463.9\r\nThe members of an away team investigating the death of an engineer encounter vengeful microscopic life forms.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177880"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 19,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 18,
				"dvdSeason": 1,
				"episodeName": "Coming of Age",
				"firstAired": "1988-03-14",
				"id": 46526,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959966,
				"overview": "Stardate: 41416.2\r\nWhile Wesley takes the entrance exam to Starfleet Academy, the Enterprise is investigated by the Inspector General's office and Picard's competency is questioned.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177881"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 20,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 19,
				"dvdSeason": 1,
				"episodeName": "Heart of Glory",
				"firstAired": "1988-03-21",
				"id": 46527,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959950,
				"overview": "Stardate: 41503.7\r\nTwo Klingons, rescued by the Enterprise, try to take over the ship.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177882"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 21,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 20,
				"dvdSeason": 1,
				"episodeName": "The Arsenal of Freedom",
				"firstAired": "1988-04-11",
				"id": 46528,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959942,
				"overview": "Stardate: 41798.2\r\nThe crew encounters bizarre phenomena while searching for the missing U.S.S. Drake.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177883"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 22,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 21,
				"dvdSeason": 1,
				"episodeName": "Symbiosis",
				"firstAired": "1988-04-18",
				"id": 46529,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959935,
				"overview": "Stardate: Unknown\r\nPicard attempts to break an ancient co-dependency between two species on one planet without violating the Prime Directive.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177884"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 23,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 22,
				"dvdSeason": 1,
				"episodeName": "Skin of Evil",
				"firstAired": "1988-04-25",
				"id": 46530,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959926,
				"overview": "Stardate: 41601.3\r\nWhen Troi's shuttle crashes on an alien planet, a new being is discovered: an entity that thrives on the suffering of others. ",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177885"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 24,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 23,
				"dvdSeason": 1,
				"episodeName": "We'll Always Have Paris",
				"firstAired": "1988-05-02",
				"id": 46531,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959920,
				"overview": "Stardate: 41697.9\r\nPicard meets an old flame, whose husband has created a haywire dimensional experiment.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177886"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 25,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 24,
				"dvdSeason": 1,
				"episodeName": "Conspiracy",
				"firstAired": "1988-05-09",
				"id": 46532,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959909,
				"overview": "Stardate: 41775.5\r\nThe strange behavior of high-ranking officers leads Picard to uncover a twisted alien conspiracy within Starfleet.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177887"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 26,
				"airedSeason": 1,
				"airedSeasonID": 2298,
				"dvdEpisodeNumber": 25,
				"dvdSeason": 1,
				"episodeName": "The Neutral Zone",
				"firstAired": "1988-05-16",
				"id": 46533,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959901,
				"overview": "Stardate: 41986.0\r\nA derelict satellite is found with cryonically frozen humans aboard as the USS Enterprise is sent to investigate the destruction of outposts near Romulan space.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177888"
				}
			}
		],
		"airedSeason": 1,
		"title": "Season 1"
	},
	{
		"episodes": [
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 1,
				"airedSeason": 2,
				"airedSeasonID": 2299,
				"dvdEpisodeNumber": 1,
				"dvdSeason": 2,
				"episodeName": "The Child",
				"firstAired": "1988-11-21",
				"id": 46534,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959845,
				"overview": "Stardate: 42073.1\r\nTroi undergoes a mysterious pregnancy when the Enterprise tries to escape from a system that has recently fallen victim to a deadly plague.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177889"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 2,
				"airedSeason": 2,
				"airedSeasonID": 2299,
				"dvdEpisodeNumber": 2,
				"dvdSeason": 2,
				"episodeName": "Where Silence Has Lease",
				"firstAired": "1988-11-28",
				"id": 46535,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959837,
				"overview": "Stardate: 42193.6\r\nA mysterious life form known as the 'Nagilum' threatens the life of the crew in his attempt to understand humanity.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177890"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 3,
				"airedSeason": 2,
				"airedSeasonID": 2299,
				"dvdEpisodeNumber": 3,
				"dvdSeason": 2,
				"episodeName": "Elementary, Dear Data",
				"firstAired": "1988-12-05",
				"id": 46536,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959827,
				"overview": "Stardate: 42286.3\r\nData and Geordi become involved with a holodeck program about Sherlock Holmes and his investigations, when they create Sherlock's arch nemesis, Moriarty; however, modifications to the Moriarty character include the capability of out-smarting Data, which leads to some unexpected consequences.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177891"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 4,
				"airedSeason": 2,
				"airedSeasonID": 2299,
				"dvdEpisodeNumber": 4,
				"dvdSeason": 2,
				"episodeName": "The Outrageous Okona",
				"firstAired": "1988-12-12",
				"id": 46537,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959819,
				"overview": "Stardate: 42402.7\r\nThe Enterprise is placed in a compromising situation when the captain of a disabled starship places the crew in the middle of a love triangle.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177892"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 5,
				"airedSeason": 2,
				"airedSeasonID": 2299,
				"dvdEpisodeNumber": 5,
				"dvdSeason": 2,
				"episodeName": "Loud as a Whisper",
				"firstAired": "1989-01-09",
				"id": 46538,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959812,
				"overview": "Stardate: 42477.2\r\nA deaf-mute mediator meets with disaster while being escorted by the Enterprise.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177893"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 6,
				"airedSeason": 2,
				"airedSeasonID": 2299,
				"dvdEpisodeNumber": 6,
				"dvdSeason": 2,
				"episodeName": "The Schizoid Man",
				"firstAired": "1989-01-23",
				"id": 46539,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959804,
				"overview": "Stardate: 42437.5\r\nData is possessed by the consciousness of a brilliant scientist. However, it has a disturbing impact on Data's personality.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177894"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 7,
				"airedSeason": 2,
				"airedSeasonID": 2299,
				"dvdEpisodeNumber": 7,
				"dvdSeason": 2,
				"episodeName": "Unnatural Selection",
				"firstAired": "1989-01-30",
				"id": 46540,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959797,
				"overview": "Stardate: 42494.8\r\nA mysterious hyper-ageing sickness kills the crew of a Federation cargo ship, and Dr. Pulaski must race against time to find a cure.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177895"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 8,
				"airedSeason": 2,
				"airedSeasonID": 2299,
				"dvdEpisodeNumber": 8,
				"dvdSeason": 2,
				"episodeName": "A Matter of Honor",
				"firstAired": "1989-02-06",
				"id": 46541,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959786,
				"overview": "Commander Riker participates in an officer's exchange program which lands him an assignment on a Klingon Bird-of-Prey.  Meanwhile, a Bezite ensign has trouble assimilating to the routines of the Enterprise.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177896"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 9,
				"airedSeason": 2,
				"airedSeasonID": 2299,
				"dvdEpisodeNumber": 9,
				"dvdSeason": 2,
				"episodeName": "The Measure of a Man",
				"firstAired": "1989-02-13",
				"id": 46542,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959780,
				"overview": "Stardate: 42523.7\r\nWhen Data's rights as a sentient individual are placed under trial, Starfleet forces Riker into a position where he must prove that Data is only an Android.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177897"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 10,
				"airedSeason": 2,
				"airedSeasonID": 2299,
				"dvdEpisodeNumber": 10,
				"dvdSeason": 2,
				"episodeName": "The Dauphin",
				"firstAired": "1989-02-20",
				"id": 46543,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959770,
				"overview": "Stardate: 42568.8\r\nWesley falls in love with a passenger the Enterprise is escorting, who has the secret ability to shape-shift.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177898"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 11,
				"airedSeason": 2,
				"airedSeasonID": 2299,
				"dvdEpisodeNumber": 11,
				"dvdSeason": 2,
				"episodeName": "Contagion",
				"firstAired": "1989-03-20",
				"id": 46544,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959762,
				"overview": "Stardate: 42609.1\r\nA strange power source disables the Enterprise's computer systems, damages Data's programming and leaves the ship and crew vulnerable to a Romulan attack.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177899"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 12,
				"airedSeason": 2,
				"airedSeasonID": 2299,
				"dvdEpisodeNumber": 12,
				"dvdSeason": 2,
				"episodeName": "The Royale",
				"firstAired": "1989-03-27",
				"id": 46545,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959754,
				"overview": "Stardate: 42625.4\r\nAn away team is trapped in an alien environment based around a novel entitled 'The Hotel Royale.'",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177900"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 13,
				"airedSeason": 2,
				"airedSeasonID": 2299,
				"dvdEpisodeNumber": 13,
				"dvdSeason": 2,
				"episodeName": "Time Squared",
				"firstAired": "1989-04-03",
				"id": 46546,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959747,
				"overview": "Stardate: 42679.2\r\nPicard encounters his double from six hours in the future, whose Enterprise had been destroyed.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177901"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 14,
				"airedSeason": 2,
				"airedSeasonID": 2299,
				"dvdEpisodeNumber": 14,
				"dvdSeason": 2,
				"episodeName": "The Icarus Factor",
				"firstAired": "1989-04-24",
				"id": 46547,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959738,
				"overview": "Stardate: 42686.4\r\nRiker is promoted to Captain of another Federation ship. Worf must confront his past and his Klingon heritage.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177902"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 15,
				"airedSeason": 2,
				"airedSeasonID": 2299,
				"dvdEpisodeNumber": 15,
				"dvdSeason": 2,
				"episodeName": "Pen Pals",
				"firstAired": "1989-05-01",
				"id": 46548,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959730,
				"overview": "Stardate: 42695.3\r\nWesley must investigate the causes of strange tectonic activity on the planet where Data's pen pal lives.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177903"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 16,
				"airedSeason": 2,
				"airedSeasonID": 2299,
				"dvdEpisodeNumber": 16,
				"dvdSeason": 2,
				"episodeName": "Q Who?",
				"firstAired": "1989-05-08",
				"id": 46549,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959722,
				"overview": "Stardate: 42761.3\r\nQ hurls the Enterprise into the Delta Quadrant and introduces the Federation to a powerful new enemy that may destroy the Alpha Quadrant: The Borg.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177904"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 17,
				"airedSeason": 2,
				"airedSeasonID": 2299,
				"dvdEpisodeNumber": 17,
				"dvdSeason": 2,
				"episodeName": "Samaritan Snare",
				"firstAired": "1989-05-15",
				"id": 46550,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959716,
				"overview": "Stardate: 42779.1\r\nA race known as the Pakleds kidnap Geordi La Forge. Picard must face surgery when he is left in a near-dead state.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177905"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 18,
				"airedSeason": 2,
				"airedSeasonID": 2299,
				"dvdEpisodeNumber": 18,
				"dvdSeason": 2,
				"episodeName": "Up the Long Ladder",
				"firstAired": "1989-05-22",
				"id": 46551,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959707,
				"overview": "Stardate: 42823.2\r\nPicard must convince two dying civilizations that they must co-exist on the same planet to survive, however, they have other plans to ensure their survival: in the form of clones of the Enterprise crew.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177906"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 19,
				"airedSeason": 2,
				"airedSeasonID": 2299,
				"dvdEpisodeNumber": 19,
				"dvdSeason": 2,
				"episodeName": "Manhunt",
				"firstAired": "1989-06-19",
				"id": 46552,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959700,
				"overview": "Stardate: 42859.2\r\nWhile being escorted to a Federation conference by the Enterprise, Lwaxana hunts for a man to satisfy her needs when her sex-drive is quadrupled during a natural mid-life cycle.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177907"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 20,
				"airedSeason": 2,
				"airedSeasonID": 2299,
				"dvdEpisodeNumber": 20,
				"dvdSeason": 2,
				"episodeName": "The Emissary",
				"firstAired": "1989-06-29",
				"id": 46553,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959694,
				"overview": "Stardate: 42901.3\r\nWorf is re-united with his former lover, K'Ehleyr, while the Enterprise is ordered to intercept a Klingon ship whose crew has been in stasis for a century.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177908"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 21,
				"airedSeason": 2,
				"airedSeasonID": 2299,
				"dvdEpisodeNumber": 21,
				"dvdSeason": 2,
				"episodeName": "Peak Performance",
				"firstAired": "1989-07-10",
				"id": 46554,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959687,
				"overview": "Stardate: 42923.4\r\nTrouble begins when a Ferengi warship stumbles over a war simulation between Riker and Picard, each on different ships, and begins attacking them.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177909"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 22,
				"airedSeason": 2,
				"airedSeasonID": 2299,
				"dvdEpisodeNumber": 22,
				"dvdSeason": 2,
				"episodeName": "Shades of Gray",
				"firstAired": "1989-07-17",
				"id": 46555,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959680,
				"overview": "Stardate: 42976.1\r\nRiker is infected with an alien organism that takes over his mind. Dr. Pulaski must force Riker's mind back to a state where it can access primitive survival skills.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177910"
				}
			}
		],
		"airedSeason": 2,
		"title": "Season 2"
	},
	{
		"episodes": [
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 1,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 1,
				"dvdSeason": 3,
				"episodeName": "Evolution",
				"firstAired": "1989-09-25",
				"id": 46556,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1451476819,
				"overview": "Stardate: 43125.8\r\nA system-wide computer malfunction places the crew of the U.S.S. Enterprise in grave danger while they are escorting a scientist to a star in the process of exploding.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177911"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 2,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 2,
				"dvdSeason": 3,
				"episodeName": "The Ensigns of Command",
				"firstAired": "1989-10-02",
				"id": 46557,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1451477094,
				"overview": "Stardate: 43133.3\r\nA human colony is forced to evacuate a planet when the original inhabitants return and threaten the colonists with annihilation if they do not leave within four days.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177912"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 3,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 3,
				"dvdSeason": 3,
				"episodeName": "The Survivors",
				"firstAired": "1989-10-09",
				"id": 46558,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1451477261,
				"overview": "Stardate: 43152.4\r\nThe Enterprise discovers a planet that has had all life eradicated, except for two mysterious residents and their home, which has been left in perfect condition.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177913"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 4,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 4,
				"dvdSeason": 3,
				"episodeName": "Who Watches the Watchers",
				"firstAired": "1989-10-16",
				"id": 46559,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1451477367,
				"overview": "Stardate: 43173.5\r\nAn away team inadvertently breaks the Prime Directive and reveal themselves to a primitive culture on Mintaka III, causing the inhabitants believe that Captain Picard is a God.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177914"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 5,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 5,
				"dvdSeason": 3,
				"episodeName": "The Bonding",
				"firstAired": "1989-10-23",
				"id": 46560,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1451477475,
				"overview": "Worf and Wesley must help a 12 year old boy cope with the death of his mother; an archaeologist killed during an away mission to a deserted planet.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177915"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 6,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 6,
				"dvdSeason": 3,
				"episodeName": "Booby Trap",
				"firstAired": "1989-10-30",
				"id": 46561,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428959579,
				"overview": "Stardate: 43205.6\r\nWhile investigating an ancient ship left adrift in space, the Enterprise accidentally trips the ancient booby trap that disabled the old vessel over 1000 years ago.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177916"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 7,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 7,
				"dvdSeason": 3,
				"episodeName": "The Enemy",
				"firstAired": "1989-11-06",
				"id": 46562,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1451477822,
				"overview": "Stardate:43349.2\r\nA blind Geordie is trapped on a hazardous planet with a paranoid and severely injured Romulan. In orbit, a Romulan Warbird is preventing the Enterprise from attempting a rescue mission.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177917"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 8,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 8,
				"dvdSeason": 3,
				"episodeName": "The Price",
				"firstAired": "1989-11-13",
				"id": 46563,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1452167141,
				"overview": "Stardate: 43385.6\r\nThe Enterprise hosts the negotiations for the rights to a newly discovered, stable wormhole to the Delta Quadrant. One of the negotiators, Devinoni Ral, becomes attracted to Deanna Troi, but he holds a dubious secret.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177918"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 9,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 9,
				"dvdSeason": 3,
				"episodeName": "The Vengeance Factor",
				"firstAired": "1989-11-20",
				"id": 46564,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1452167296,
				"overview": "Stardate: 43421.9\r\nThe Enterprise crew tries to mend the relationship between a race known as the Acamarians and a faction known as the Gatherers.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177919"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 10,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 10,
				"dvdSeason": 3,
				"episodeName": "The Defector",
				"firstAired": "1990-01-01",
				"id": 46565,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472987541,
				"overview": "Stardate: 43462.5\r\nA defecting Romulan warns the Federation about an impending attack by the Romulans, who are secretly establishing bases within the Neutral Zone.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177920"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 11,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 11,
				"dvdSeason": 3,
				"episodeName": "The Hunted",
				"firstAired": "1990-01-08",
				"id": 46566,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472987553,
				"overview": "Stardate: 43489.2\r\nA potentially new member of the Federation enlists the help of the Enterprise to track down a wanted criminal who has a reputation for his excessive violence. However, the fugitive's actions may not be of his own will.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177921"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 12,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 12,
				"dvdSeason": 3,
				"episodeName": "The High Ground",
				"firstAired": "1990-01-29",
				"id": 46567,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472987565,
				"overview": "Stardate: 43510.7\r\nDr. Crusher is abducted by a group of terrorists while delivering crucial medical supplies to a planet ravaged by civil war.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177922"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 13,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 13,
				"dvdSeason": 3,
				"episodeName": "Déjà Q",
				"firstAired": "1990-02-05",
				"id": 46568,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472987577,
				"overview": "Stardate: 43539.1\r\nA Calamarian starts attacking the Enterprise while seeking revenge on a powerless Q.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177923"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 14,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 14,
				"dvdSeason": 3,
				"episodeName": "A Matter of Perspective",
				"firstAired": "1990-02-12",
				"id": 46569,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472987655,
				"overview": "Stardate: 43610.4\r\nRiker is accused of murder when a scientist is killed in an explosion. Picard must recreate the recent events in the holodeck to prove his commander's innocence.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177924"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 15,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 15,
				"dvdSeason": 3,
				"episodeName": "Yesterday's Enterprise",
				"firstAired": "1990-02-19",
				"id": 46570,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472987666,
				"overview": "Stardate: 43625.2\r\nA rift in the space/time continuum brings the U.S.S. Enterprise - C forward into the 24th Century, and alters the timeline. In this future, the Federation is at war with the Klingons, Tasha Yar is on the bridge, Worf did not join the Federation, and only Guinan's unique perception of reality may restore the timeline.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177925"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 16,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 16,
				"dvdSeason": 3,
				"episodeName": "The Offspring",
				"firstAired": "1990-03-12",
				"id": 46571,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472987689,
				"overview": "Stardate: 43657.0\r\nData becomes a father when he creates a Soong-type android in the form of a daughter named Lal. Issues are complicated when Lal starts showing signs of a more evolved consciousness, including the ability to feel emotions, which attracts the attention of Starfleet scientists who want to take her away from Data and examine her advanced systems.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177926"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 17,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 17,
				"dvdSeason": 3,
				"episodeName": "Sins of the Father",
				"firstAired": "1990-03-19",
				"id": 46572,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472987700,
				"overview": "Stardate: 43685.2\r\nWorf is reunited with his long-lost brother when their father is charged with treason for helping the Romulans. Together they make an appeal to the Klingon High Council to challenge the charges, and have them revoked.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177927"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 18,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 18,
				"dvdSeason": 3,
				"episodeName": "Allegiance",
				"firstAired": "1990-03-26",
				"id": 46573,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472987715,
				"overview": "Stardate: 43714.1\r\nPicard is secretly abducted and switched with an alien double. The crews' suspicions are raised when he starts exhibiting unusual behaviour, and is relieved of command.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177928"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 19,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 19,
				"dvdSeason": 3,
				"episodeName": "Captain's Holiday",
				"firstAired": "1990-04-02",
				"id": 46574,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472987726,
				"overview": "Stardate: 43745.2\r\nWhile on vacation on Risa, Captain Picard encounters two Vorgons from the 27th Century who claim they are searching for a powerful weapon hidden somewhere on the planet.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177929"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 20,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 20,
				"dvdSeason": 3,
				"episodeName": "Tin Man",
				"firstAired": "1990-04-23",
				"id": 46575,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472987747,
				"overview": "Stardate: 43779.3\r\nThe Enterprise encounters a 'living' ship in the Neutral Zone, and risks breaking the Romulan Federation alliance in order to bring it into contact with a Betazoid emissary.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177930"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 21,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 21,
				"dvdSeason": 3,
				"episodeName": "Hollow Pursuits",
				"firstAired": "1990-04-30",
				"id": 46576,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472987759,
				"overview": "Stardate: 43807.4\r\nA nervous and insecure officer, Lt. Reginald Barclay, places the Enterprise in great danger when he neglects his duties in Engineering, and instead spends his time acting out his fantasies on the holodeck.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177931"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 22,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 22,
				"dvdSeason": 3,
				"episodeName": "The Most Toys",
				"firstAired": "1990-05-07",
				"id": 46577,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472987786,
				"overview": "Stardate: 43872.2\r\nThe crew are shattered by the apparent death of Data in a shuttle explosion, and are prevented from carrying out a detailed investigation when Starfleet gives them orders for a new mission elsewhere. However, the crew don't realize that he was actually abducted and placed on display as part of a collection of rare and valuable items held by a disreputable character.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177932"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 23,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 23,
				"dvdSeason": 3,
				"episodeName": "Sarek",
				"firstAired": "1990-05-14",
				"id": 46578,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472987797,
				"overview": "Stardate: 43917.4\r\nSpock's Vulcan father, Sarek, boards the Enterprise to negotiate political relations with the Legaran. However, Sarek has contract Bendii syndrome, which causes a Vulcan to gradually lose control, and become overpowered with emotions.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177933"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 24,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 24,
				"dvdSeason": 3,
				"episodeName": "Ménage à Troi",
				"firstAired": "1990-05-28",
				"id": 46579,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472987808,
				"overview": "Riker and Deanna, both on shoreleave, are unexpectedly joined by Deanna's mother, Lwaxana, on Betazed. Shortly, all three are kidnapped by the Ferengi who want to study Lwaxana's telepathic abilities.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177934"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 25,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 25,
				"dvdSeason": 3,
				"episodeName": "Transfigurations",
				"firstAired": "1990-06-04",
				"id": 46580,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472987829,
				"overview": "Stardate: 43957.2\r\nDr. Crusher becomes attracted to an injured alien with mysterious powers, who is being tracked down by his government like a wanted criminal.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177935"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 26,
				"airedSeason": 3,
				"airedSeasonID": 2300,
				"dvdEpisodeNumber": 26,
				"dvdSeason": 3,
				"episodeName": "The Best of Both Worlds (1)",
				"firstAired": "1990-06-18",
				"id": 46581,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472987840,
				"overview": "Stardate: 43989.1\r\nAn Starfleet expert on the Borg, Lt. Cmdr. Shelby, is assigned to the Enterprise to investigate the disappearance of a Federation colony. Picard is abducted by the Borg and assimilated into the Collective, which forces Riker to attempt a rescue mission.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177936"
				}
			}
		],
		"airedSeason": 3,
		"title": "Season 3"
	},
	{
		"episodes": [
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 1,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 1,
				"dvdSeason": 4,
				"episodeName": "The Best of Both Worlds (2)",
				"firstAired": "1990-09-24",
				"id": 46582,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472988282,
				"overview": "Riker must pull out all the stops in order to save Earth from a Borg invasion being lead by none other than Locutus - otherwise known as Captain Jean-Luc Picard.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177937"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 2,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 2,
				"dvdSeason": 4,
				"episodeName": "Family",
				"firstAired": "1990-10-01",
				"id": 46583,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472988293,
				"overview": "Picard meets with his older brother in France, and contemplates resigning his Starfleet commission after his ordeal with the Borg. Worf's adoptive parents spend time with their son on the Enterprise, and succeed in embarrassing him in front of his crewmates.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177938"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 3,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 3,
				"dvdSeason": 4,
				"episodeName": "Brothers",
				"firstAired": "1990-10-08",
				"id": 46584,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472988305,
				"overview": "While escorting a seriously ill boy to the closest Federation Starbase for treatment, Data mysteriously takes control of the Enterprise and takes it to a distant planet. He learns that his creator has summoned him for an important meeting that could change his life. However, Dr. Soong unknowingly summoned Data's twin brother Lore, into the bargain.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177939"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 4,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 4,
				"dvdSeason": 4,
				"episodeName": "Suddenly Human",
				"firstAired": "1990-10-15",
				"id": 46585,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472988316,
				"overview": "A custody battle between Picard and a child's adoptive father arises when a boy showing evidence of abuse is discovered.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177940"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 5,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 5,
				"dvdSeason": 4,
				"episodeName": "Remember Me",
				"firstAired": "1990-10-22",
				"id": 46586,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472988327,
				"overview": "Dr. Crusher begins to question her sanity when members of the crew start disappearing one by one, and all evidence of their existence is erased.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177941"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 6,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 6,
				"dvdSeason": 4,
				"episodeName": "Legacy",
				"firstAired": "1990-10-29",
				"id": 46587,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472988340,
				"overview": "The Enterprise is caught in the middle of a civil war when they encounter Tasha Yar's long-lost younger sister, Ishara.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177942"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 7,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 7,
				"dvdSeason": 4,
				"episodeName": "Reunion",
				"firstAired": "1990-11-05",
				"id": 46588,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472988365,
				"overview": "Picard is asked to choose between two candidates to succeed the current Chancellor of the Klingon High Council as the new ruler of the Empire. Worf is disturbed by unexpected news when he is paid a visit by his former lover.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177943"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 8,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 8,
				"dvdSeason": 4,
				"episodeName": "Future Imperfect",
				"firstAired": "1990-11-12",
				"id": 46589,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472988379,
				"overview": "Riker awakens one morning to discover he is suddenly 16 years in the future as the captain of the Enterprise, and negotiating a peace treaty with the Romulans with no recollection of how he arrived at that point in time, or of any recent events.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177944"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 9,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 9,
				"dvdSeason": 4,
				"episodeName": "Final Mission",
				"firstAired": "1990-11-19",
				"id": 46590,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472988399,
				"overview": "Wesley must keep Captain Picard alive on the eve of his entrance exam to Starfleet Academy when their shuttle crashes on a barren moon.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177945"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 10,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 10,
				"dvdSeason": 4,
				"episodeName": "The Loss",
				"firstAired": "1990-12-01",
				"id": 46591,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472988422,
				"overview": "Troi loses her empathic abilities when the Enterprise is caught in the gravitational pull of a black hole.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177946"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 11,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 11,
				"dvdSeason": 4,
				"episodeName": "Data's Day",
				"firstAired": "1991-01-07",
				"id": 46592,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989048,
				"overview": "A Vulcan Ambassador being escorted by the Enterprise starts exhibiting suspicious behavior. Miles O'Brien marries his fiancée, Keiko Ishikawa in Ten-Forward.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177947"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 12,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 12,
				"dvdSeason": 4,
				"episodeName": "The Wounded",
				"firstAired": "1991-01-28",
				"id": 46593,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989074,
				"overview": "When the Cardassians start re-arming themselves, a Federation Captain takes it upon himself to remove a potential threat before it escalated. Now, Picard must fight for the Cardassians and stop the renegade from slaughtering innocents.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177948"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 13,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 13,
				"dvdSeason": 4,
				"episodeName": "Devil's Due",
				"firstAired": "1991-02-04",
				"id": 46594,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989086,
				"overview": "The crew of the Enterprise must defend the planet Ventax from a mythological Devil who re-appears when a 1000 year long era of peace comes to an end.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177949"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 14,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 14,
				"dvdSeason": 4,
				"episodeName": "Clues",
				"firstAired": "1991-02-11",
				"id": 46595,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989097,
				"overview": "Picard orders a secret investigation when the crew suspects Data of lying about the discovery of a wormhole.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177950"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 15,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 15,
				"dvdSeason": 4,
				"episodeName": "First Contact",
				"firstAired": "1991-02-18",
				"id": 46596,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989108,
				"overview": "Riker is abducted by a xenophobic race of aliens during a first contact mission. They believe the Enterprise is a scout for an invasion.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177951"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 16,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 16,
				"dvdSeason": 4,
				"episodeName": "Galaxy's Child",
				"firstAired": "1991-03-11",
				"id": 46597,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989119,
				"overview": "Geordi must work with the real Leah Brahms when she arrives on the Enterprise when a space-borne alien life form thinks the ship is its mother. Tensions rise when she learns that Geordi created a holographic version of her several months before in order to save the ship from danger.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177952"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 17,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 19,
				"dvdSeason": 4,
				"episodeName": "Night Terrors",
				"firstAired": "1991-03-18",
				"id": 46598,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989130,
				"overview": "Troi faces a recurring nightmare when the Enterprise is caught in a rift in space. Soon, the crew begins to slip into insanity through dream deprivation.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177953"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 18,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 17,
				"dvdSeason": 4,
				"episodeName": "Identity Crisis",
				"firstAired": "1991-03-25",
				"id": 46599,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989150,
				"overview": "Geordi and a former crew mate begin evolving into bizarre creatures when they return to a planet both of them were on during an Away Mission five years earlier.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177954"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 19,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 18,
				"dvdSeason": 4,
				"episodeName": "The Nth Degree",
				"firstAired": "1991-04-01",
				"id": 46600,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989162,
				"overview": "An alien probe transforms Barclay from a shy, awkward character into an arrogant super-genius who is able to interface with the Enterprise's computer through the holodeck.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177955"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 20,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 20,
				"dvdSeason": 4,
				"episodeName": "Qpid",
				"firstAired": "1991-04-22",
				"id": 46601,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989172,
				"overview": "Q places Vash and the senior Enterprise crew in a recreation of Robin Hood and his merry men.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177956"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 21,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 21,
				"dvdSeason": 4,
				"episodeName": "The Drumhead",
				"firstAired": "1991-04-29",
				"id": 46602,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989371,
				"overview": "Picard is accused of treason when an explosion aboard the Enterprise is investigated by a ruthless and paranoid Starfleet Admiral.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177957"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 22,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 22,
				"dvdSeason": 4,
				"episodeName": "Half a Life",
				"firstAired": "1991-05-06",
				"id": 46603,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989381,
				"overview": "Lwaxana Troi falls in love with a man who must return home to commit suicide, as is customary for their race when they reach a certain age.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177958"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 23,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 23,
				"dvdSeason": 4,
				"episodeName": "The Host",
				"firstAired": "1991-05-13",
				"id": 46604,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989392,
				"overview": "Dr. Crusher falls in love with a Trill Ambassador, until she discovers the Trill's symbiotic relationship.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177959"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 24,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 24,
				"dvdSeason": 4,
				"episodeName": "The Mind's Eye",
				"firstAired": "1991-05-27",
				"id": 46605,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989405,
				"overview": "While en route to Risa for shore leave, Geordi is abducted by the Romulans and brainwashed into becoming an assassin.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177960"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 25,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 25,
				"dvdSeason": 4,
				"episodeName": "In Theory",
				"firstAired": "1991-06-03",
				"id": 46606,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989417,
				"overview": "Data experiences the complexities of love when a fellow crewmate becomes attracted to him.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177961"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 26,
				"airedSeason": 4,
				"airedSeasonID": 2301,
				"dvdEpisodeNumber": 26,
				"dvdSeason": 4,
				"episodeName": "Redemption (1)",
				"firstAired": "1991-06-17",
				"id": 46607,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989428,
				"overview": "Worf must choose between his people and the Federation when a civil war threatens to destroy the Klingon Empire.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177962"
				}
			}
		],
		"airedSeason": 4,
		"title": "Season 4"
	},
	{
		"episodes": [
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 1,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 1,
				"dvdSeason": 5,
				"episodeName": "Redemption (2)",
				"firstAired": "1991-09-23",
				"id": 46608,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989839,
				"overview": "Stardate: 45020.4 - Picard suspects a Romulan influence in the recent Klingon civil war, and must force the Federation to intervene before the Empire collapses.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177963"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 2,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 2,
				"dvdSeason": 5,
				"episodeName": "Darmok",
				"firstAired": "1991-09-30",
				"id": 46609,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989847,
				"overview": "Stardate: 45047.2 - Picard must find a way to communicate with the newly discovered Tamarians, who speak entirely in metaphors, when a Tamarian Captain is brutally killed.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177964"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 3,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 3,
				"dvdSeason": 5,
				"episodeName": "Ensign Ro",
				"firstAired": "1991-10-07",
				"id": 46610,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989855,
				"overview": "Stardate: 45076.3 - Picard exposes a planned genocidal attack on the Bajorans with the help of a new officer, Ensign Ro Laren.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177965"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 4,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 4,
				"dvdSeason": 5,
				"episodeName": "Silicon Avatar",
				"firstAired": "1991-10-14",
				"id": 46611,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989864,
				"overview": "Stardate: 45122.3 - Picard attempts communications with the Crystalline Entity - a life form responsible for hundreds of deaths throughout the Alpha Quadrant. However, a scientist on board the Enterprise has plans of revenge over the death of her only son at the hands of the Entity.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177966"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 5,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 5,
				"dvdSeason": 5,
				"episodeName": "Disaster",
				"firstAired": "1991-10-21",
				"id": 46612,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989874,
				"overview": "Stardate: 45156.1 - A natural disaster leaves Troi in command of the Enterprise, Picard stuck in a turbo lift with three small children and Keiko O'Brien stuck in Ten-Forward giving birth with an anxious Worf.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177967"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 6,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 6,
				"dvdSeason": 5,
				"episodeName": "The Game",
				"firstAired": "1991-10-28",
				"id": 46613,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989943,
				"overview": "Stardate: 45208.2 - An addictive game is distributed among the crew of the Enterprise, however, it appears that this game interferes with a person's logic and reason, which leaves the crew open to manipulation. Only a young Ensign and a vacationing Wesley Crusher are able to think for themselves, and must find a way to reverse the damage before the ship falls into the wrong hands.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177968"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 7,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 7,
				"dvdSeason": 5,
				"episodeName": "Unification (1)",
				"firstAired": "1991-11-04",
				"id": 46614,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989953,
				"overview": "Ambassador Spock has dissapeared and intelligence finds him on Romulus.  Captain Picard is sent to Romulus to find Spock.  Meanwhile Riker and the rest of the crew investigate the fragments of a Vulcan ship discovered in the wreck of a Ferengi vessel.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177969"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 8,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 8,
				"dvdSeason": 5,
				"episodeName": "Unification (2)",
				"firstAired": "1991-11-11",
				"id": 46615,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989961,
				"overview": "Stardate: 45245.8 - Picard and Data find Spock and discover the reason behind the secret meetings. However, a darker scheme planned by the Romulans is also uncovered in the process.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177970"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 9,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 9,
				"dvdSeason": 5,
				"episodeName": "A Matter of Time",
				"firstAired": "1991-11-18",
				"id": 46616,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989971,
				"overview": "Stardate: 45349.1 - While on a mission to help a planet recently struck by an asteroid, the Enterprise is payed a visit by a man who claims to be from the future.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177971"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 10,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 10,
				"dvdSeason": 5,
				"episodeName": "New Ground",
				"firstAired": "1992-01-06",
				"id": 46617,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472989981,
				"overview": "Stardate: 45376.3 - Worf's son, Alexander, unexpectedly arrives on the Enterprise to stay with his father. However, Alexander wants to stay permanently.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177972"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 11,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 11,
				"dvdSeason": 5,
				"episodeName": "Hero Worship",
				"firstAired": "1992-01-27",
				"id": 46618,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472990290,
				"overview": "Stardate: 45397.3 - The Enterprise investigates the cause of an explosion which destroyed a small ship and its entire crew, except for a small boy.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177973"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 12,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 12,
				"dvdSeason": 5,
				"episodeName": "Violations",
				"firstAired": "1992-02-03",
				"id": 46619,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472990307,
				"overview": "Stardate: 45419.3 - While escorting a group of telepaths, crew members on board the Enterprise suddenly start to slip into comas.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177974"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 13,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 13,
				"dvdSeason": 5,
				"episodeName": "The Masterpiece Society",
				"firstAired": "1992-02-10",
				"id": 46620,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472990316,
				"overview": "Stardate: 45470.1 - A natural disaster in the core of a system's sun threatens to destroy a colony of genetically engineered people on an otherwise desolate planet. However, the crew's intervention may cause more harm than good.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177975"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 14,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 14,
				"dvdSeason": 5,
				"episodeName": "Conundrum",
				"firstAired": "1992-02-17",
				"id": 46621,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472990326,
				"overview": "Stardate: 45494.2 - The Enterprise crew unknowingly receives a new first officer who claims that the Federation is at war with another species.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177976"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 15,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 15,
				"dvdSeason": 5,
				"episodeName": "Power Play",
				"firstAired": "1992-02-24",
				"id": 46622,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472990336,
				"overview": "Stardate: 45571.2 - While en route to the source of a subspace distress signal coming from a desolate moon, Data, Troi and O'Brien take over the bridge and force the ship to change course.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177977"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 16,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 16,
				"dvdSeason": 5,
				"episodeName": "Ethics",
				"firstAired": "1992-03-02",
				"id": 46623,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472990504,
				"overview": "Stardate: 45587.3 - When Worf is paralysed in an accident he must undergo drastic back surgery. However, this experimental technique may cost him his life.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177978"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 17,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 17,
				"dvdSeason": 5,
				"episodeName": "The Outcast",
				"firstAired": "1992-03-16",
				"id": 46624,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472990515,
				"overview": "Stardate: 45614.6 - While investigating the disappearance of a J'naii shuttlecraft, the crew finds reason to believe the missing ship is stranded in an abnormal pocket called \"null space.\" Riker and Soren, a member of the J'naii race, begin preparing to rescue the craft, and the two strike up a friendship. Their relationship develops quickly as the pair question each other about mating habits, since the J'naii are androgynous and do not identify themselves as either male or female. Despite this difference, sparks begin to fly between them.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177979"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 18,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 18,
				"dvdSeason": 5,
				"episodeName": "Cause and Effect",
				"firstAired": "1992-03-23",
				"id": 46625,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472990524,
				"overview": "Stardate: 45652.1 - While exploring the Typhon Expanse, the Enterprise is caught in a time warp in which they are repeatedly destroyed while colliding with another starship.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177980"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 19,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 19,
				"dvdSeason": 5,
				"episodeName": "The First Duty",
				"firstAired": "1992-03-30",
				"id": 46626,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472990534,
				"overview": "Stardate: 45703.9 - Wesley is involved in a cover-up at Starfleet Academy when a cadet is killed and five shuttles are destroyed during a forbidden maneuver performed by Starfleet Academy's best cadets.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177981"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 20,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 20,
				"dvdSeason": 5,
				"episodeName": "Cost of Living",
				"firstAired": "1992-04-20",
				"id": 46627,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472990545,
				"overview": "Stardate: 45733.63 - Deanna's mother pays a surprise visit to the Enterprise with even more surprising news: she plans to marry a man she has never met. After destroying an asteroid, the ship becomes infected with parasites that eat away at the ship's hull.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177982"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 21,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 21,
				"dvdSeason": 5,
				"episodeName": "The Perfect Mate",
				"firstAired": "1992-04-27",
				"id": 46628,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472990764,
				"overview": "Stardate: 45761.3 - The Ferengi try to abduct an empathic Metamorph who could bring peace between two warring worlds.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177983"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 22,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 22,
				"dvdSeason": 5,
				"episodeName": "Imaginary Friend",
				"firstAired": "1992-05-04",
				"id": 46629,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472990772,
				"overview": "Stardate: 45832.1 - While exploring a strange form of energy in a region of space, a little girl's imaginary friend becomes real and places the Enterprise in great danger.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177984"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 23,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 23,
				"dvdSeason": 5,
				"episodeName": "I, Borg",
				"firstAired": "1992-05-11",
				"id": 46630,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472990781,
				"overview": "Stardate: 45832.1 - An injured Borg is discovered and brought back to the Enterprise where he is 'repaired' by Dr. Crusher and befriended by Geordi, who names him 'Hugh.' Soon, Hugh starts showing signs of individuality while Picard must choose between destroying him or returning him to the collective.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177985"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 24,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 24,
				"dvdSeason": 5,
				"episodeName": "The Next Phase",
				"firstAired": "1992-05-18",
				"id": 46631,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472990790,
				"overview": "Stardate: 45092.4 - While the Enterprise helps a Romulan science vessel, an accident occurs which forces Geordi LaForge and Ro Laren slightly out of 'phase', causing them to become undetectable to everyone but each other. As a result, the crew thinks they are dead and make arrangements for their funerals, even though they are closer than the crew realise.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177986"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 25,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 25,
				"dvdSeason": 5,
				"episodeName": "The Inner Light",
				"firstAired": "1992-06-01",
				"id": 46632,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472990800,
				"overview": "Picard is struck by an energy beam from an alien probe, which renders him unconscious and places him in the life of a citizen on the planet Kataan, with his memory of the Enterprise intact.  Although he searches for a way to return, he finally decides to live his life with his Kataan wife, have children & grandchildren, learning to play a flute and completely immersing in the Kataan culture. He finds the planet is dying due to an imbalance of its sun.  With no way to evacuate the planet's people, the government builds a probe which will tell others how they lived.  The same probe that Picard met.  Picard wakes to find himself back on the Enterprise having lived an entire lifetime in just minutes.  The probe, having disgorged its memories, gives one last gift:  the flute (which shows up in later episodes.)",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177987"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 26,
				"airedSeason": 5,
				"airedSeasonID": 2302,
				"dvdEpisodeNumber": 26,
				"dvdSeason": 5,
				"episodeName": "Time's Arrow (1)",
				"firstAired": "1992-06-15",
				"id": 46633,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472990811,
				"overview": "Stardate: 45959.1 - Data's head is uncovered in an archaeological dig on Earth, where evidence is also found that aliens may have been on Earth as early as the 19th Century. Using modified technology, an away team follows Data into the late 1890s to investigate.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177988"
				}
			}
		],
		"airedSeason": 5,
		"title": "Season 5"
	},
	{
		"episodes": [
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 1,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 1,
				"dvdSeason": 6,
				"episodeName": "Time's Arrow (2)",
				"firstAired": "1992-09-21",
				"id": 46634,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472990940,
				"overview": "Stardate: 46001.3 - The away team's investigations are hampered by a nosy Samuel Clemens. Picard discovers that he originally met Guinan in the 1890s on Earth.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177989"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 2,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 2,
				"dvdSeason": 6,
				"episodeName": "Realm of Fear",
				"firstAired": "1992-09-28",
				"id": 46635,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472990954,
				"overview": "Stardate: 46041.4 - Lt. Barclay's fear of using transporters is eerily justified when he sees bizarre aliens within the transporter beam.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177990"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 3,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 3,
				"dvdSeason": 6,
				"episodeName": "Man of the People",
				"firstAired": "1992-10-05",
				"id": 46636,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472990967,
				"overview": "Stardate: 46071.6 - Deanna becomes attracted to an alien ambassador. Shortly thereafter, she starts ageing rapidly and starts becoming violent.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177991"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 4,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 4,
				"dvdSeason": 6,
				"episodeName": "Relics",
				"firstAired": "1992-10-12",
				"id": 46637,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472991500,
				"overview": "Stardate: 46125.3 - Montgomery 'Scotty' Scott is discovered suspended in a transporter beam 75 years after he disappeared. After the Enterprise crew re-materialise him, he has a hard time adjusting to the new society.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177992"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 5,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 5,
				"dvdSeason": 6,
				"episodeName": "Schisms",
				"firstAired": "1992-10-19",
				"id": 46638,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1473096413,
				"overview": "Stardate: 46154.2 - Members of the crew are secretly abducted from the Enterprise to be used in bizarre experiments where they are dismembered and re-assembled without anyone's knowledge - including their own. The only signs that anything is wrong is a strange form of tiredness and no recollection of having slept well the night before.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177993"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 6,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 6,
				"dvdSeason": 6,
				"episodeName": "True Q",
				"firstAired": "1992-10-26",
				"id": 46639,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472991987,
				"overview": "Stardate: 46192.3 - A young intern visiting the Enterprise captures the interest of Q when she starts displaying Q-like powers.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177994"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 7,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 7,
				"dvdSeason": 6,
				"episodeName": "Rascals",
				"firstAired": "1992-11-02",
				"id": 46640,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1473096487,
				"overview": "Stardate: 46235.7 - A transporter accident transforms Picard, Ro Laren, Guinan and Keiko O'Brien into small children who appear to be about 12 years old. Matters are complicated when the Ferengi seize the Enterprise.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177995"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 8,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 8,
				"dvdSeason": 6,
				"episodeName": "A Fistful of Datas",
				"firstAired": "1992-11-09",
				"id": 46641,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1473096684,
				"overview": "Stardate: 46271.5 - Worf and his son, Alexander, become trapped in the holodeck when their Wild West program malfunctions. However, they must find a way to defeat the holographic bandits who have Data's appearance and abilities.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177996"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 9,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 9,
				"dvdSeason": 6,
				"episodeName": "The Quality of Life",
				"firstAired": "1992-11-16",
				"id": 46642,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1473096742,
				"overview": "Stardate: 46315.2 - Data discovers that the maintance robots built by Dr. Farallon may have become sentient.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177997"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 10,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 10,
				"dvdSeason": 6,
				"episodeName": "Chain of Command (1)",
				"firstAired": "1992-12-14",
				"id": 46643,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1473096783,
				"overview": "Stardate: 46357.4 - Picard resigns as Captain of the Enterprise to lead a top-secret espionage mission into Cardassia with Worf and Dr. Crusher.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177998"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 11,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 11,
				"dvdSeason": 6,
				"episodeName": "Chain of Command (2)",
				"firstAired": "1992-12-21",
				"id": 46644,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1473096874,
				"overview": "Stardate: 46360.8 - Picard is captured and tortured by the Cardassians, while Riker tries to prevent a Federation attack on Cardassia.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70177999"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 12,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 12,
				"dvdSeason": 6,
				"episodeName": "Ship in a Bottle",
				"firstAired": "1993-01-25",
				"id": 46645,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1473097068,
				"overview": "Stardate: 46424.1 - While performing holodeck maintenance, Barclay accesses the stored hologram of Professor Moriarty, who wreaks havoc on board the Enterprise.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178000"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 13,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 13,
				"dvdSeason": 6,
				"episodeName": "Aquiel",
				"firstAired": "1993-02-01",
				"id": 46646,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1473097165,
				"overview": "Stardate: 46461.3 - Geordie falls in love with a lieutenant who is the prime suspect in a murder case.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178001"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 14,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 14,
				"dvdSeason": 6,
				"episodeName": "Face of the Enemy",
				"firstAired": "1993-02-08",
				"id": 46647,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1473097367,
				"overview": "Stardate: 46519.1 - Troi is abducted and surgically altered by the Romulans as part of a ploy to smuggle intelligence operatives into the Federation.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178002"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 15,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 15,
				"dvdSeason": 6,
				"episodeName": "Tapestry",
				"firstAired": "1993-02-15",
				"id": 46648,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472991296,
				"overview": "Stardate: Unknown - A mortally wounded Picard is forced into re-living a time of his life when he was back in Starfleet Academy, with the intervention of Q.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178003"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 16,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 16,
				"dvdSeason": 6,
				"episodeName": "Birthright (1)",
				"firstAired": "1993-02-22",
				"id": 46649,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1473097509,
				"overview": "Stardate: 46578.4 - While visiting Deep Space Nine, Worf learns that his father is still alive and being held captive in a secret Romulan prison camp.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178004"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 17,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 17,
				"dvdSeason": 6,
				"episodeName": "Birthright (2)",
				"firstAired": "1993-03-01",
				"id": 46650,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1473097652,
				"overview": "Stardate: 46759.2 - Worf is captured by the Romulans where he learns why the other captives did not attempt an escape years before.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178005"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 18,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 18,
				"dvdSeason": 6,
				"episodeName": "Starship Mine",
				"firstAired": "1993-03-29",
				"id": 46651,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1473097948,
				"overview": "Stardate: 46682.4 - The crew evacuates the Enterprise when the ship needs to be cleaned of particles that have built up over the ship's hull. However, Picard accidentally stumbles over a terrorist group who plan on destroying the ship. He only has a short time to stop their attempts before the ship is swept by a beam of radiation to remove the particles that is lethal to all forms of life.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178006"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 19,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 19,
				"dvdSeason": 6,
				"episodeName": "Lessons",
				"firstAired": "1993-04-05",
				"id": 46652,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1473098118,
				"overview": "Stardate: 46693.1 - Picard must choose between love and command when he must make a decision that could place the woman he loves in a potentially deadly and high-risk mission.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178007"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 20,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 20,
				"dvdSeason": 6,
				"episodeName": "The Chase",
				"firstAired": "1993-04-26",
				"id": 46653,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1473098243,
				"overview": "Stardate: 46731.5 - Picard's old archaeology professor is found murdered, the crew try to complete his research. Soon, the crew must compete with Romulans and Klingons and Cardassians to uncover the truth behind his discoveries.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178008"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 21,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 21,
				"dvdSeason": 6,
				"episodeName": "Frame of Mind",
				"firstAired": "1993-05-03",
				"id": 46654,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1473098416,
				"overview": "Stardate: 46778.1 - Riker questions his sanity when his reality seems to shift between an alien psychiatric hospital and a play he is performing with other members of the crew.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178009"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 22,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 22,
				"dvdSeason": 6,
				"episodeName": "Suspicions",
				"firstAired": "1993-05-10",
				"id": 46655,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1473098538,
				"overview": "Stardate: 46830.1 - Dr. Crusher puts her career on the line when she tries to clear the name of a murdered scientist whose invention could allow starships to pass through a sun's corona.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178010"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 23,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 23,
				"dvdSeason": 6,
				"episodeName": "Rightful Heir",
				"firstAired": "1993-05-17",
				"id": 46656,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1473098611,
				"overview": "Stardate: 46852.2 - While on a quest to summon a vision of Kahless, Worf questions his faith when the real Kahless rises from the dead to lead the Empire.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178011"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 24,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 24,
				"dvdSeason": 6,
				"episodeName": "Second Chances",
				"firstAired": "1993-05-24",
				"id": 46657,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1473099078,
				"overview": "Stardate: 46915.2 - Riker discovers that eight years ago, an exact clone of him was created when he beamed through a planet's surface while returning to his starship. This clone, named Thomas Riker, has secretly remained on the planet for the past eight years, and still has romantic feelings for Troi.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178012"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 25,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 25,
				"dvdSeason": 6,
				"episodeName": "Timescape",
				"firstAired": "1993-06-14",
				"id": 46658,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472992487,
				"overview": "Stardate: 46944.2 - Picard, Geordi, Troi and Data return from a Federation conference to find the Enterprise frozen in time and under attack from a frozen Romulan Warbird.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178013"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 26,
				"airedSeason": 6,
				"airedSeasonID": 2303,
				"dvdEpisodeNumber": 26,
				"dvdSeason": 6,
				"episodeName": "Descent (1)",
				"firstAired": "1993-06-21",
				"id": 46659,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472992591,
				"overview": "Stardate: 46982.1 - The Borg return to threaten the Federation under the new leadership of Lore. Data experiences a disturbing facet of human emotions - he feels pleasure after killing a Borg drone.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178014"
				}
			}
		],
		"airedSeason": 6,
		"title": "Season 6"
	},
	{
		"episodes": [
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 1,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 1,
				"dvdSeason": 7,
				"episodeName": "Descent (2)",
				"firstAired": "1993-09-20",
				"id": 46660,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428958126,
				"overview": "Stardate: 47025.4 - Data abducts Picard, Troi and Geordi and holds them prisoners of the Borg, while he derives pleasure from being evil. Dr. Crusher is left in command of the Enterprise as it comes under attack from a Borg vessel.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178015"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 2,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 2,
				"dvdSeason": 7,
				"episodeName": "Liaisons",
				"firstAired": "1993-09-27",
				"id": 46661,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428958135,
				"overview": "Stardate: Unknown - During an exchange program, Picard's shuttle crashes on an unknown planet where he is rescued by the sole survivor of another crash.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178016"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 3,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 3,
				"dvdSeason": 7,
				"episodeName": "Interface",
				"firstAired": "1993-10-04",
				"id": 46662,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428958146,
				"overview": "Stardate: 47215.5 - Geordi defies direct orders from Captain Picard in an attempt to rescue his mother who had recently been reported as missing.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178017"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 4,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 4,
				"dvdSeason": 7,
				"episodeName": "Gambit (1)",
				"firstAired": "1993-10-11",
				"id": 46663,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428958157,
				"overview": "Stardate: 47135.2 - An away team investigates the apparent death of Jean-Luc Picard who was supposedly killed in a bar fight. When Riker is abducted by a band of criminals who loot archaeological digs, he is shocked to find Picard alive and well, and undercover as a renegade archaeologist.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178018"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 5,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 5,
				"dvdSeason": 7,
				"episodeName": "Gambit (2)",
				"firstAired": "1993-10-18",
				"id": 46664,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428958168,
				"overview": "Stardate: 47160.1 - Picard and Riker covertly work together in an attempt to find out why the criminals are looting archaeological digs.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178019"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 6,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 6,
				"dvdSeason": 7,
				"episodeName": "Phantasms",
				"firstAired": "1993-10-25",
				"id": 46665,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472992735,
				"overview": "Stardate: 47225.7 - Data's new dream subroutine causes him to experience nightmares which provide a unique insight into strange events that are occurring on board the Enterprise.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178020"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 7,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 7,
				"dvdSeason": 7,
				"episodeName": "Dark Page",
				"firstAired": "1993-11-01",
				"id": 46666,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428958190,
				"overview": "Stardate: 47254.1 - Lwaxana Troi collapses with a repressed memory related illness. Her only chance for survival is if Deanna can probe her subconscious and find out what is killing her. However, the secret Lwaxana holds is deeper than Deanna imagined.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178021"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 8,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 8,
				"dvdSeason": 7,
				"episodeName": "Attached",
				"firstAired": "1993-11-08",
				"id": 46667,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428958204,
				"overview": "Stardate: 47304.2 - While on a a diplomatic mission, Dr. Crusher and Picard are captured and imprisoned. As a result, they are linked together via a telepathic device.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178022"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 9,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 9,
				"dvdSeason": 7,
				"episodeName": "Force of Nature",
				"firstAired": "1993-11-15",
				"id": 46668,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428958218,
				"overview": "Stardate: 47310.2 - The Enterprise is drawn to a region of space where many starships have been mysteriously disabled. They soon learn that a brother and sister team has been working together to bring attention to the fact that frequent high-warp travel is damaging the very fabric of space/time.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178023"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 10,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 10,
				"dvdSeason": 7,
				"episodeName": "Inheritance",
				"firstAired": "1993-11-22",
				"id": 46669,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428958226,
				"overview": "Stardate: 47410.2 - Data is disturbed by the claims of a woman who says she is Noonien Soong's ex-wife.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178024"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 11,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 11,
				"dvdSeason": 7,
				"episodeName": "Parallels",
				"firstAired": "1993-11-29",
				"id": 46670,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428958236,
				"overview": "Stardate: 47391.2 - Worf returns from a Klingon competition to find that he is shifting through different realities.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178025"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 12,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 12,
				"dvdSeason": 7,
				"episodeName": "The Pegasus",
				"firstAired": "1994-01-17",
				"id": 46671,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428958242,
				"overview": "Stardate: 47457.1 - Riker is placed on a covert mission to find the missing starship he was once a member aboard, but the mission holds a secret that could destroy the peace treaty between the Federation and the Romulans.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178026"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 13,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 13,
				"dvdSeason": 7,
				"episodeName": "Homeward",
				"firstAired": "1994-01-17",
				"id": 46672,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428958255,
				"overview": "Stardate: 47423.9 - Worf's adoptive brother violates the Prime Directive to save an alien society whose planet is dying.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178027"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 14,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 14,
				"dvdSeason": 7,
				"episodeName": "Sub Rosa",
				"firstAired": "1994-01-31",
				"id": 46673,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428958269,
				"overview": "Stardate: Unknown - Dr. Crusher attends her grandmother's funeral, to find that she had been in romantic encounters with a mysterious man who had been haunting the Howard family women for generations.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178028"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 15,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 15,
				"dvdSeason": 7,
				"episodeName": "Lower Decks",
				"firstAired": "1994-02-07",
				"id": 46674,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428958278,
				"overview": "Stardate: 47566.7 - Four young ensigns compete for a promotion that only one of them will receive. However, they are soon placed on a top secret mission that places some of their lives in danger.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178029"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 16,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 16,
				"dvdSeason": 7,
				"episodeName": "Thine Own Self",
				"firstAired": "1994-02-14",
				"id": 46675,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428958287,
				"overview": "Stardate: 47611.2 - Data find himself mysteriously stranded on a planet with no recollection of who he is or how he arrived there. Soon he is accused of spreading a plague among the inhabitants. Troi takes the bridge officer's test in an attempt to gain the rank of Commander.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178030"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 17,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 17,
				"dvdSeason": 7,
				"episodeName": "Masks",
				"firstAired": "1994-02-21",
				"id": 46676,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428958294,
				"overview": "Stardate: 47615.2 - The Enterprise is slowly transformed into an ancient alien temple when Data discovers an alien archive full of information about an ancient culture. Shortly after opening the archive, Data becomes possessed with several different personalities.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178031"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 18,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 18,
				"dvdSeason": 7,
				"episodeName": "Eye of the Beholder",
				"firstAired": "1994-02-28",
				"id": 46677,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428958306,
				"overview": "Stardate: 47622.1 - While investigating the mysterious suicide of a crew member, Troi and Worf begin to show romantic feeling towards one another.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178032"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 19,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 19,
				"dvdSeason": 7,
				"episodeName": "Genesis",
				"firstAired": "1994-03-21",
				"id": 46678,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428958315,
				"overview": "Stardate: 47653.2 - Upon returning from an away mission, Picard and Data find the ship drifting in space, and the crew de-evolving into their animal ancestors.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178033"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 20,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 20,
				"dvdSeason": 7,
				"episodeName": "Journey's End",
				"firstAired": "1994-03-28",
				"id": 46679,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428958324,
				"overview": "Stardate: 47751.2 - Under the terms of the new Federation/Cardassian alliance, Picard is ordered to evacuate a colony of native Americans, but protests from Wesley hamper the process. Wesley's destiny is finally revealed to him when the Traveler returns.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178034"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 21,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 21,
				"dvdSeason": 7,
				"episodeName": "Firstborn",
				"firstAired": "1994-04-25",
				"id": 46680,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428958335,
				"overview": "Stardate: 47779.4 - A disinterested Alexander must face his first Right of Ascension passage, but a mysterious warrior by the name of K'Mtar brings with him a disturbing request.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178035"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 22,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 22,
				"dvdSeason": 7,
				"episodeName": "Bloodlines",
				"firstAired": "1994-05-02",
				"id": 46681,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428958344,
				"overview": "Stardate: 47829.1 - Picard tries to save his newly-discovered son from the retaliation of a vengeful Ferengi whose only son was killed by Picard buring the Battle of Maxia many years before.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178036"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 23,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 23,
				"dvdSeason": 7,
				"episodeName": "Emergence",
				"firstAired": "1994-05-09",
				"id": 46682,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428958354,
				"overview": "Stardate: 47869.2 - The Enterprise's computer systems starts having repeated malfunctions, leading the crew to believe that it may be evolving into a new life form.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178037"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 24,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 24,
				"dvdSeason": 7,
				"episodeName": "Preemptive Strike",
				"firstAired": "1994-05-16",
				"id": 46683,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1428958362,
				"overview": "Stardate: 47941.7 - Fresh from Starfleet's Advanced Tactical Training course, Ro Laren is assigned to infiltrate the Maquis. However, over time she begins to sympathize with them, which forces her to choose between her loyalty to the Federation, and her new friends in the Maquis.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178038"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 25,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 25.1,
				"dvdSeason": 7,
				"episodeName": "All Good Things... (1)",
				"firstAired": "1994-05-23",
				"id": 46684,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472992960,
				"overview": "Stardate: 47988.0 - Shortly after Picard is diagnosed with a long-term, potentially debilitating brain disorder, he starts experiencing bizarre shifts into three main time periods: 25 years into the future, a few days before the Enterprise-D is sent on its mission to Farpoint station, and the present. Picard realizes that Q is behind these shifts through time. Q finally reveals himself that humanity is still on trial, and that Picard must stop an event in the future that will halt the formation of life on Earth four billion years ago.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178039"
				}
			},
			{
				"absoluteNumber": null,
				"airedEpisodeNumber": 26,
				"airedSeason": 7,
				"airedSeasonID": 2304,
				"dvdEpisodeNumber": 25.2,
				"dvdSeason": 7,
				"episodeName": "All Good Things... (2)",
				"firstAired": "1994-05-23",
				"id": 405273,
				"language": {
					"episodeName": "en",
					"overview": "en"
				},
				"lastUpdated": 1472992970,
				"overview": "Stardate:  47988.1 - After his encounter with Q, Picard assembles the senior staff, and wonders if Q is actually giving him a chance to save humanity by showing him that the spatial anomaly also exists in the past. As they talk, the ship reaches the Neutral Zone, then Picard returns to the future, where Beverly's ship is also on the edge of the Neutral Zone. He convinces a reluctant Worf to accompany the group into Klingon territory, and then travels to the past, where he orders the crew into the Devron system. Finally, he returns to the present, where he is able to get Tomalak, the Romulan Commander on the other side of the border, to agree to entering the Neutral Zone together. Now heading for the anomaly in all three time periods, Picard learns that it exists in the present, and is larger in the past, but does not exist in the future.",
				"playLinks": {
					"netflix": "http://www.netflix.com/watch/70178039"
				}
			}
		],
		"airedSeason": 7,
		"title": "Season 7"
	}
];

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(25)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(44),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-badc7e0c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(26)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(45),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(40),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(22)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(39),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4bd571c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(36),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(24)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(18),
  /* template */
  __webpack_require__(43),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8e978c86",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(41),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('strong', [_c('div', [_vm._v("\n          Random episode from season:\n      ")]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.getAnyRandomEpisode
    }
  }, [_vm._v("Any")])]), _vm._v(" "), _vm._l((_vm.epData), function(season) {
    return _c('span', {
      key: season.title
    }, [_vm._v("\n         \n        "), _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.getSeasonRandomEpisode(season.airedSeason)
        }
      }
    }, [_vm._v("\n          " + _vm._s(season.airedSeason) + "\n        ")])])
  })], 2)]), _vm._v(" "), _c('div', [_c('strong', [_c('div', [_vm._v("\n          Browse episodes from season:\n      ")]), _vm._v(" "), _vm._l((_vm.epData), function(season) {
    return _c('span', {
      key: season.title
    }, [_vm._v("\n         \n        "), _c('router-link', {
      attrs: {
        "to": {
          path: '/Browse/Season/' + season.airedSeason
        }
      }
    }, [_vm._v("\n          " + _vm._s(season.airedSeason) + "\n        ")])], 1)
  })], 2)]), _vm._v(" "), _c('div', [_c('strong', [_c('router-link', {
    attrs: {
      "to": "/DrinkingRules"
    }
  }, [_vm._v("Drinking Rules")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.episode.id),
      expression: "episode.id"
    }]
  }, [_c('div', {
    staticClass: "ep-data"
  }, [_c('img', {
    attrs: {
      "src": _vm.episodeImage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ep-data-text"
  }, [_c('p', [_c('strong', [_vm._v("S" + _vm._s(_vm.episode.airedSeason) + "E" + _vm._s(_vm.episode.airedEpisodeNumber) + " - " + _vm._s(_vm.episode.episodeName))])]), _vm._v(" "), _c('p', [_c('small', [(_vm.lastSeen < Date.now() - 1000) ? _c('span', [_vm._v("Last viewed: " + _vm._s(new Date(_vm.episode.viewedAt)))]) : _vm._e()])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.episode.overview))]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.episode.playLinks.netflix,
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('h3', [_vm._v("Play in Netflix!")])])])])]), _vm._v(" "), _c('drinking-rules')], 1)
},staticRenderFns: []}

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('bg-video'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('logo'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('app-footer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "browse-season"
  }, [_c('h3', [_vm._v(_vm._s(_vm.season.title))]), _vm._v(" "), _c('ul', _vm._l((_vm.season.episodes), function(episode) {
    return _c('li', {
      key: episode.airedEpisodeNumber
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: ("/Browse/Season/" + (_vm.season.airedSeason) + "/Episode/" + (episode.airedEpisodeNumber))
        }
      }
    }, [_vm._v("\n        E" + _vm._s(episode.airedEpisodeNumber) + " - "), _c('strong', [_vm._v(_vm._s(episode.episodeName))])])], 1)
  }))])
},staticRenderFns: []}

/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "browse-episode"
  }, [_c('episode', {
    attrs: {
      "episode": _vm.episode
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "random-episode"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.getRandomEpisode
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.msg))])]), _vm._v(" "), _c('episode', {
    attrs: {
      "episode": _vm.episode
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rules"
  }, [_c('h3', [_vm._v("Drinking Rules:")]), _vm._v(" "), _c('ul', _vm._l((_vm.rules), function(rule) {
    return _c('li', [_vm._v(_vm._s(rule))])
  }))])
},staticRenderFns: []}

/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('svg', {
    attrs: {
      "id": "logo",
      "width": "374.628",
      "height": "92.172",
      "viewBox": "0 0 351.21374 86.411154"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5.2 37.2h16.72q3.84 0 6.48-1.2 2.24-1.28 2.24-4.8 0-3.36-6.8-6-6.72-2.64-6.72-9.84 0-6.24 2.72-10.4t10-4.16H50.4l-4.32 10H35.76q-3.12 0-4.4.8-1.28.72-1.28 3.36 0 2.16 6.88 4.32 6.96 2.08 6.96 9.92t-5.6 13.52Q32.8 48.4 24.08 48.4H0l5.2-11.2zM47.611 48.4l13.36-30h12.32l-13.12 30h-12.56zm8.56-37.6l4.56-10h29.84l-4.32 10h-30.08zM71.886 48.4l25.84-30h10.72l-16.16 18.8h13.92l7.44-23.44q.4-1.44-.96-2.16-1.28-.8-2.56-.8h-12.8l4.48-10h23.6q1.36 0 2.24.88.88.88.88 2.48 0 .96-.32 1.84l-13.6 42.4h-42.72zM129.826 18.4h18.88q2 0 3.28-2l1.6-3.6q.48-.96-.48-1.36-.96-.48-2-.64h-18l4.48-10h27.6q1.68 0 3.04 1.04 1.36.96 1.36 2.56l-.24 1.2-8.24 18.16q-.96 2.4-3.12 3.6-.16.08-1.44.56-1.28.48-2.08.48.72.4 1.52 1.44.8.96.8 2.32 0 1.28-.56 2.4l-6.32 13.84h-12.48l7.92-17.44.16-.72q0-.64-.48-1.12-.48-.48-1.36-.72h-5.84l-8.8 20h-12.56l13.36-30zM198.14 48.4l13.36-30h12.32l-13.12 30h-12.56zm8.56-37.6l4.56-10h29.84l-4.32 10H206.7zM237.215 18.4h18.88q2 0 3.28-2l1.6-3.6q.48-.96-.48-1.36-.96-.48-2-.64h-18l4.48-10h27.6q1.68 0 3.04 1.04 1.36.96 1.36 2.56l-.24 1.2-8.24 18.16q-.96 2.4-3.12 3.6-.16.08-1.44.56-1.28.48-2.08.48.72.4 1.52 1.44.8.96.8 2.32 0 1.28-.56 2.4l-6.32 13.84h-12.48l7.92-17.44.16-.72q0-.64-.48-1.12-.48-.48-1.36-.72h-5.84l-8.8 20h-12.56l13.36-30zM276.81 10.8l4.48-10h28.4l-4.32 10h-28.56zm-16.64 37.6l13.36-30h28.4l-4.32 10h-16.08l-3.92 8.8h16l-4.8 11.2h-28.64zM311.774.8h12.4l-2.08 4.8q2.16-2.16 7.2-3.84Q334.414 0 340.974 0l4 .08h1.52l1.76.16 2.96.56-10.4 10h-33.52l4.48-10zm-21.12 47.6l13.36-30h12.32q5.6 0 8.56 2 3.04 2 5.92 8l9.44 20h-12.48l-6.32-13.6-2.32-4.72q-1.12-1.68-2.64-1.68h-4.48l-8.8 20h-12.56z"
    }
  }), _c('path', {
    attrs: {
      "d": "M.211 86.331l6.68-15h6.16l-6.56 15H.211zm4.28-18.8l2.28-5h14.92l-2.16 5H4.491zM14.024 86.331l10.56-23.8h6.2l-3.92 8.8h11.12l-2.28 5h-11l-4.44 10.08-6.24-.08zM41.953 67.531l2.24-5h14.2l-2.16 5h-14.28zm-8.32 18.8l6.68-15h14.2l-2.16 5h-8.04l-1.96 4.4h8l-2.4 5.6h-14.32zM97.224 62.531q1.44 0 1.44 1.68 0 .52-.36 1.6l-7.64 17.32q-.6 1.36-1.88 2.28-1.24.92-3.12.92h-14.96l6.68-15h6.2l-4.16 9.4h4.36q1 0 1.56-.44.56-.48 1.08-1.68l3.88-8.8q.24-.56.24-.96 0-1.32-2.96-1.32h-8.56l2.24-5h15.96zM99.272 71.331h9.44q1 0 1.64-1l.8-1.8q.24-.48-.24-.68-.48-.24-1-.32h-9l2.24-5h13.8q.84 0 1.52.52.68.48.68 1.28l-.12.6-4.12 9.08q-.48 1.2-1.56 1.8-.08.04-.72.28-.64.24-1.04.24.36.2.76.72.4.48.4 1.16 0 .64-.28 1.2l-3.16 6.92h-6.24l3.96-8.72.08-.36q0-.32-.24-.56-.24-.24-.68-.36h-2.92l-4.4 10h-6.28l6.68-15zM112.745 86.331l10.56-23.8h6.2l-10.48 23.8h-6.28zM135.303 71.331l-6.6 15h-6.28l6.68-15h6.2zm-4.56-3.8l2.24-5h14.16q1.16 0 1.92.64.8.6.8 1.92l-.04.76q0 .44-.2.96-.08.4-.2.72-.12.28-.48 1.08l-7.8 17.72h-6.24l7.44-16.8.2-.84q0-1.16-2.24-1.16H130.743zM154.193 62.531h6.2l-1.04 2.4q1.08-1.08 3.6-1.92 2.56-.88 5.84-.88l2 .04h.76l.88.08 1.48.28-5.2 5h-16.76l2.24-5zm-10.56 23.8l6.68-15h6.16q2.8 0 4.28 1 1.52 1 2.96 4l4.72 10h-6.24l-3.16-6.8-1.16-2.36q-.56-.84-1.32-.84h-2.24l-4.4 10h-6.28zM171.026 86.331l10.56-23.8h6.2l-10.48 23.8h-6.28zM193.584 71.331l-6.6 15h-6.28l6.68-15h6.2zm-4.56-3.8l2.24-5h14.16q1.16 0 1.92.64.8.6.8 1.92l-.04.76q0 .44-.2.96-.08.4-.2.72-.12.28-.48 1.08l-7.8 17.72h-6.24l7.44-16.8.2-.84q0-1.16-2.24-1.16H189.024zM227.754 67.531h-18.44l1-2.32q.6-1.4 1.44-2.04.56-.36.96-.48l.92-.16h16.36l-2.24 5zm-24.16 18.8q-1.44 0-1.44-1.6 0-.96.6-2.4l4.84-10.96h6.24l-3.4 7.64-.16.68q0 .32.36.76.48.28 1.12.28h2.68q.6 0 1.08-.36l.44-.48.4-.56.68-1.4.16-.6q0-.24-.24-.68l-.44-.32h-1.56l2.24-5h8.92l-5.36 12.2q-.4 1-1.64 2-1.12.8-2.68.8h-12.84zM268.301 67.531h-18.44l1-2.32q.6-1.4 1.44-2.04.56-.36.96-.48l.92-.16h16.36l-2.24 5zm-24.16 18.8q-1.44 0-1.44-1.6 0-.96.6-2.4l4.84-10.96h6.24l-3.4 7.64-.16.68q0 .32.36.76.48.28 1.12.28h2.68q.6 0 1.08-.36l.44-.48.4-.56.68-1.4.16-.6q0-.24-.24-.68l-.44-.32h-1.56l2.24-5h8.92l-5.36 12.2q-.4 1-1.64 2-1.12.8-2.68.8h-12.84zM262.654 86.331l12.92-15h5.36l-8.08 9.4h6.96l3.72-11.72q.2-.72-.48-1.08-.64-.4-1.28-.4h-6.4l2.24-5h11.8q.68 0 1.12.44.44.44.44 1.24 0 .48-.16.92l-6.8 21.2h-21.36zM296.499 62.531h10.28q1.68 0 2.56.44.88.44.88 1.16l-.12.48q.96-1.4 1.64-1.72.72-.36 1.72-.36h7.76q1.28 0 2.04.64.8.6.8 2v.76l-.2.8q0 .28-.2.68l-.44 1.08-7.76 17.84h-6.2l7.44-16.92.2-.8q0-1.08-2.36-1.08h-2.48l-8.32 18.8h-6.2l7.64-17.32.16-.68q0-.8-2.84-.8h-8.24l2.24-5zm2.32 8.8l-6.6 15h-6.28l6.68-15h6.2zM326.328 67.531l2.24-5h14.2l-2.16 5h-14.28zm-8.32 18.8l6.68-15h14.2l-2.16 5h-8.04l-1.96 4.4h8l-2.4 5.6h-14.32z"
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_vm._v("\n  Episode screens and information provided by\n  "), _c('a', {
    attrs: {
      "href": "http://thetvdb.com/"
    }
  }, [_vm._v("The TVDB")]), _vm._v(".  Please help them by\n  contibuting.\n")])
}]}

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('video', {
    attrs: {
      "id": "bg-video",
      "poster": "/static/tngscreen.jpg",
      "playsinline": "",
      "autoplay": "",
      "muted": "",
      "loop": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "/static/worf-screen.mp4",
      "type": "video/mp4"
    }
  })])
}]}

/***/ })
],[9]);


// WEBPACK FOOTER //
// static/js/app.4d17dd3d1d5ed25acbbb.js